let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kLG7c")).then(() => parcelRequire('bEkwN'));